export default __webpack_public_path__ + "static/media/4.efb6e0a9.png";